import React from "react";
import Metadata from "../CreateSite/Step2/Metadata";
import ConfidentalLeft from "../CreateSite/Step1/ConfidentialityLeft";
import GeographyLeft from "../CreateSite/Step3/GeographyLeft";
import Management from "../CreateSite/Step5/Management";
import ManagementLeft from "../CreateSite/Step5/ManagementLeft";
import Summary from "../CreateSite/Step6/Summary";
import SummaryLeft from "../CreateSite/Step6/SummaryLeft";
import {validateStep2} from "../CreateSite/Step2/Validator";
import {validate1} from "../CreateSite/Step1/Validator";
import {validateStep4} from "../CreateSite/Step4/Validator";
import {validateStep3} from "../CreateSite/Step3/Validator";
import ConfidentialAndTemplates from "../CreateSite/Step1/ConfidentialTemplatesRight";
import MetadataLeft from "../CreateSite/Step2/MetadataLeft";
import PeopleLeft from "../CreateSite/Step4/PeopleLeft";
import CombineSteps from "../CreateSite/Step3/CombineSteps";
import People from "../CreateSite/Step4/People";
import {validateStep5IATU, validateStep5} from "../CreateSite/Step5/Validator";
import {validateStep6} from "../CreateSite/Step6/Validator";

//STEPS DEFINITION

export const step1 =
    {
        id : 1,
        name : "step1",
        leftPane: <ConfidentalLeft/>,
        rightPane: <ConfidentialAndTemplates/>,
        validator: validate1
    }

export const step2 =
    {
        id : 2,
        name : "step2",
        leftPane: <MetadataLeft/>,
        rightPane: <Metadata/>,
        validator: validateStep2
    }

export const step3 =
    {
        id : 3,
        name : "step3",
        leftPane: <GeographyLeft/>,
        rightPane: <CombineSteps/>,
        validator: validateStep3
    }


export const step4 =
    {
        id : 4,
        name : "step4",
        leftPane: <PeopleLeft/>,
        rightPane: <People/>,
        validator: validateStep4
    }



export const step5IATU =
    {
        id: 5,
        name : "step5",
        leftPane: <ManagementLeft/>,
        rightPane: <Management/>,
        validator: validateStep5IATU
    }

    export const step5 =
    {
        id: 5,
        name : "step5",
        leftPane: <SummaryLeft/>,
        rightPane: <Summary/>,
        validator: validateStep5
    }

export const step6 =
    {
        id: 6,
        name : "step6",
        leftPane: <SummaryLeft/>,
        rightPane: <Summary/>,
        validator: validateStep6
    }

 export const steps =
    [
        step1,
        step2,
        step3,
        step4,
        step5
    ]

export const stepsIATU =
    [
        step1,
        step2,
        step3,
        step4,
        step5IATU,
        step6
    ]




// WEBPACK FOOTER //
// ./src/components/CreateSiteGuide/MenuSteps.js